import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components-shared/ui/carousel";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from "@/components-shared/ui/dialog";
import { dir } from "i18next";
import { Play } from "lucide-react";
import { useLocale, useTranslations } from "next-intl";
import { useState } from "react";

type Props = {
  videos?: Property["media"];
};

const DisplayVideos = ({ videos }: Props) => {
  const lang = useLocale();
  const t = useTranslations();
  const [open, setOpen] = useState(false);

  return videos?.length ? (
    <Dialog {...{ open, onOpenChange: setOpen }}>
      <DialogTrigger asChild>
        <button className="shadow-lg bg-[#EEFFEB] flex items-center gap-2 py-2 px-3 text-gray-light rounded-full">
          <span className="bg-gray-light p-1.5 rounded-full text-[#EEFFEB]">
            <Play strokeWidth="5" className="size-4" />
          </span>
          <p>{t("see_videos")}</p>
        </button>
      </DialogTrigger>
      <DialogContent data-close-hidden className="p-1">
        <DialogTitle className="hidden" />
        <DialogDescription className="hidden" />
        <Carousel
          opts={{
            direction: dir(lang),
          }}
        >
          <CarouselContent>
            {videos?.map((v) => (
              <CarouselItem
                key={v?.id}
                className="!px-0 flex justify-center items-center"
              >
                <video
                  poster={v?.thumbnailUrl}
                  controls
                  className="h-[500px] w-full rounded"
                >
                  <source src={v?.url} />
                </video>
              </CarouselItem>
            ))}
          </CarouselContent>
          {videos?.length > 1 && (
            <div className="flex justify-between items-center gap-2 mt-2 *:!rounded-xl">
              <CarouselPrevious className="rtl:rotate-180" />
              <DialogTitle>{t("videos_title")}</DialogTitle>
              <CarouselNext className="rtl:rotate-180" />
            </div>
          )}
        </Carousel>
      </DialogContent>
    </Dialog>
  ) : null;
};

export default DisplayVideos;
